export default [
    {
        id: 1,
        name_ca: 'No significativa',
        name_es: 'No significativa',
        name_en: 'Non significant'
    }, {
        id: 2,
        name_ca: 'Significativa',
        name_es: 'Significativa',
        name_en: 'Significant'
    }
]



// WEBPACK FOOTER //
// ./src/options/volatility_types.js